import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: { type: String, default: "Generating PDF…" } }

  click(event) {
    event.preventDefault()

    const url = this.element.href
    this.originalHTML = this.element.innerHTML

    this.element.classList.add("pointer-events-none", "opacity-75")
    this.element.innerHTML = `
      <svg class="h-4 w-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      ${this.textValue}
    `

    fetch(url, {
      headers: { "Accept": "application/pdf" }
    })
      .then(response => {
        if (!response.ok) throw new Error("Download failed")

        const contentType = response.headers.get("Content-Type") || ""
        if (!contentType.includes("application/pdf")) {
          throw new Error("Response was not a PDF")
        }

        const filename = this.extractFilename(response) || "document.pdf"
        return response.blob().then(blob => ({ blob, filename }))
      })
      .then(({ blob, filename }) => {
        const blobUrl = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = blobUrl
        link.download = filename
        link.style.display = "none"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
        this.reset()
      })
      .catch(() => {
        this.reset()
        alert("PDF generation failed. Please try again.")
      })
  }

  reset() {
    this.element.classList.remove("pointer-events-none", "opacity-75")
    this.element.innerHTML = this.originalHTML || `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      Download PDF
    `
  }

  extractFilename(response) {
    const disposition = response.headers.get("Content-Disposition")
    if (!disposition) return null

    const match = disposition.match(/filename="?([^";\n]+)"?/)
    return match ? match[1] : null
  }
}
